import React from 'react';
import PropTypes from 'prop-types';
import stylePropType from 'react-style-proptype';

import { Dropdown, Divider } from '../../../../../components';
import { RoleItem } from '../../atoms';

const AccessManagementDropdown = ({
  className = null,
  currentRole,
  roles,
  onSelect,
  onDelete = null,
  deleteLabel = null,
  toggleComponent,
  index = null,
  usePortal = false,
  menuStyle = null
}) => {
  const createMenuItems = (closeMenu) => {
    const menuItems = roles.map((role) => (
      <RoleItem
        key={role.id}
        name={role.name}
        current={role?.id === currentRole?.id}
        onClick={() => {
          onSelect(index, role);
          closeMenu();
        }}
      />
    ));

    if (onDelete && deleteLabel) {
      menuItems.push(
        <Divider key='divider' padding={4} />,
        <RoleItem
          key='delete'
          icon='trash-bin'
          onClick={() => {
            onDelete();
            closeMenu();
          }}
          name={deleteLabel}
        />
      );
    }

    return menuItems;
  };

  return (
    <Dropdown
      className={className}
      toggleComponent={toggleComponent}
      isNested={usePortal}
      menuStyle={menuStyle}
    >
      {(closeMenu) => createMenuItems(closeMenu)}
    </Dropdown>
  );
};

AccessManagementDropdown.propTypes = {
  className: PropTypes.string,
  currentRole: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired
  }).isRequired,
  roles: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired
    })
  ).isRequired,
  deleteLabel: PropTypes.string,
  onDelete: PropTypes.func,
  onSelect: PropTypes.func.isRequired,
  toggleComponent: PropTypes.node.isRequired,
  index: PropTypes.number,
  usePortal: PropTypes.bool,
  menuStyle: stylePropType
};

export { AccessManagementDropdown };
